import _ from 'underscore';
import GenericModel from 'js/models/generic.model';
import SurveyPageConfigModel from 'js/models/survey.page.config.model';
import VoucherPageConfigModel from 'js/models/service.page.config.model';
import InstantWinPageConfigModel from 'js/models/instantwin.page.config.model';
import i18n from 'l10n';

export default GenericModel.extend({
    urlRoot: '/CampaignCloud/Config',
    idAttribute: 'id',
    defaults: {
        title: "",
        endDate: null,
        campaignTemplateType: ""
    },
    model: {
        surveyPageConfig: SurveyPageConfigModel,
        voucherPageConfig: VoucherPageConfigModel,
        instantWinPageConfig: InstantWinPageConfigModel
    },
    parse: function (response) {
        _.keys(this.model).forEach(key => {
            var embeddedClass = this.model[key];
            var embeddedData = response[key];
            response[key] = new embeddedClass(embeddedData, {parse: true});
        });
        return response;
    },
    initialize() {

        this.setUpChangeListener("survey");
        this.setUpChangeListener("voucher");
        this.setUpChangeListener("instantWin");

        this.on('sync', e => {
            this.get('surveyPageConfig').trigger('sync', e);
            this.get('voucherPageConfig').trigger('sync', e);
            this.get('instantWinPageConfig').trigger('sync', e);
        });
    },
    setUpChangeListener: function (type) {
        this.on(`change:${type}PageConfig`, () => {
            this.get(`${type}PageConfig`).off('change').on('change', model => {
                _.forEach(model.changed, (val, key) => {
                    this.changed[`${type}PageConfig.${key}`] = val;
                });
                this.trigger('change', this.get(`${type}PageConfig`));
            });
        });
    },
    batchUpdate: function () {
        return $.ajaxDefaultQ({
            url: this.url(),
            type: 'PATCH',
            contentType: 'application/json',
            data: JSON.stringify(this.changed),
            dataType: 'json'
        }).then(response => {
            const succesful = _.filter(response, item => item.outcome === "OK");
            const errorCount = response.length - succesful.length;
            _.each(succesful, ({outcome, data}) => {
                const {attributeName} = data;
                this.syncAttribute(attributeName);
            });
            if (errorCount === 0) {
                this.trigger('sync', this);
                $.Notify.show(i18n.t("service.configsaved"));
            } else {
                $.Notify.show(i18n.t("service.confignotsaved", {count:errorCount}));
            }
        });
    }
});
